export const en = {
  misc: {
    storeName: 'Sergio Rossi',
  },
  welcome: 'Welcome to Sergio Rossi',
};
